import templateOnly from '@ember/component/template-only';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{#if @stateToLoop}}\n  <div class=\'cell auto text-right\' ...attributes>\n    <button\n      type=\'button\'\n      class=\'link-button\'\n      title={{t \'filter\'}}\n      aria-label={{t \'filter\'}}\n      data-test-on-toggle-filter\n      {{on \'click\' @onToggleFilter}}\n    >\n      <FaIcon @icon=\'filter\' aria-hidden=\'true\' />\n    </button>\n  </div>\n{{/if}}\n\n{{#if @isOpen}}\n  <div class=\'button-list\' ...attributes>\n    {{#each @stateToLoop as |status|}}\n      <button\n        type=\'button\'\n        class=\'button {{if (is-equal status @statusSelected) \"success\"}}\'\n        data-test-on-select-status\n        {{on \'click\' (fn @onSelectStatus status)}}\n      >\n        {{status.status_name}}\n      </button>\n    {{/each}}\n  </div>\n{{/if}}");

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      presentational status-filter toggle + button row for
 *              SelectAssociation's dropdown header. Template-only, no local
 *              state or actions.
 *   extends:   -
 *   template:  filter-bar.hbs
 *   args:      -
 *   uses:      - (consumes @stateToLoop/@isOpen/@statusSelected/@onToggleFilter/
 *              @onSelectStatus, all owned by select-association.js)
 *   siblings:  select-association/result-list.js, select-association.js
 *   tests:     none
 *
 * Pure template-only component: the filter toggle button and, when open, the
 * per-status button list, both driven entirely by args from the parent
 * SelectAssociation component.
 */
var filterBar = setComponentTemplate(TEMPLATE, templateOnly());

export { filterBar as default };
//# sourceMappingURL=filter-bar.js.map
